/**
 * @flow
 * @relayHash f7bdc5d9ee37f42db7b2a83aa8ebfa19
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ModifySocialNetworkConnectionMutation_esMutationVariables = {|
  input: {
    action: "CONNECT" | "DISCONNECT";
    userId: string;
    socialNetworkName?: ?"FACEBOOK" | "INSTAGRAM" | "PINTEREST";
    accessToken?: ?string;
    userSocialNetworkId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ModifySocialNetworkConnectionMutation_esMutationResponse = {|
  +modifySocialNetworkConnection: ?{|
    +removedId: ?string;
    +user: ?{| |};
  |};
|};
*/


/*
mutation ModifySocialNetworkConnectionMutation_esMutation(
  $input: ModifySocialNetworkConnectionInput!
) {
  modifySocialNetworkConnection(input: $input) {
    removedId
    user {
      ...AccountSettings_user
      ...PinterestPinIcon_user
      id
    }
  }
}

fragment AccountSettings_user on User {
  serviceId
  facebookUserSocialNetwork: socialNetworks(socialNetworkNames: [FACEBOOK]) {
    __typename
    ...FacebookAccountSettings_userSocialNetwork
    ... on Node {
      id
    }
  }
  pinterestUserSocialNetwork: socialNetworks(socialNetworkNames: [PINTEREST]) {
    __typename
    ...PinterestAccountSettings_userSocialNetwork
    ... on Node {
      id
    }
  }
}

fragment PinterestPinIcon_user on User {
  serviceId
  socialNetworks(socialNetworkNames: [PINTEREST]) {
    __typename
    ... on PinterestSocialNetwork {
      ...PinterestConnectBoardModal_userSocialNetwork
      status
    }
    ... on Node {
      id
    }
  }
}

fragment PinterestConnectBoardModal_userSocialNetwork on PinterestSocialNetwork {
  pinterest {
    boards {
      serviceId
      name
      url
      id
    }
    id
  }
  userPreferences {
    board
  }
}

fragment FacebookAccountSettings_userSocialNetwork on UserSocialNetwork {
  ... on FacebookSocialNetwork {
    serviceId
    socialId
    status
  }
}

fragment PinterestAccountSettings_userSocialNetwork on UserSocialNetwork {
  ... on PinterestSocialNetwork {
    ...PinterestConnectBoardModal_userSocialNetwork
    serviceId
    status
    pinterest {
      boards {
        name
        url
        id
      }
      id
    }
    userPreferences {
      board
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifySocialNetworkConnectionInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifySocialNetworkConnectionMutation_esMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifySocialNetworkConnectionInput!"
          }
        ],
        "concreteType": "ModifySocialNetworkConnectionPayload",
        "name": "modifySocialNetworkConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "removedId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "AccountSettings_user",
                "args": null
              },
              {
                "kind": "FragmentSpread",
                "name": "PinterestPinIcon_user",
                "args": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ModifySocialNetworkConnectionMutation_esMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifySocialNetworkConnectionInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ModifySocialNetworkConnectionMutation_esMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifySocialNetworkConnectionInput!"
          }
        ],
        "concreteType": "ModifySocialNetworkConnectionPayload",
        "name": "modifySocialNetworkConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "removedId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "facebookUserSocialNetwork",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "socialNetworkNames",
                    "value": [
                      "FACEBOOK"
                    ],
                    "type": "[SocialNetworkNames]"
                  }
                ],
                "concreteType": null,
                "name": "socialNetworks",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "FacebookSocialNetwork",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "socialId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "socialNetworks{\"socialNetworkNames\":[\"FACEBOOK\"]}"
              },
              {
                "kind": "LinkedField",
                "alias": "pinterestUserSocialNetwork",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "socialNetworkNames",
                    "value": [
                      "PINTEREST"
                    ],
                    "type": "[SocialNetworkNames]"
                  }
                ],
                "concreteType": null,
                "name": "socialNetworks",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "PinterestSocialNetwork",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Pinterest",
                        "name": "pinterest",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "PinterestBoard",
                            "name": "boards",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "PinterestSocialNetworkUserPreferencesType",
                        "name": "userPreferences",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "board",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "socialNetworks{\"socialNetworkNames\":[\"PINTEREST\"]}"
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "socialNetworkNames",
                    "value": [
                      "PINTEREST"
                    ],
                    "type": "[SocialNetworkNames]"
                  }
                ],
                "concreteType": null,
                "name": "socialNetworks",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "PinterestSocialNetwork",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Pinterest",
                        "name": "pinterest",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "PinterestBoard",
                            "name": "boards",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "PinterestSocialNetworkUserPreferencesType",
                        "name": "userPreferences",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "board",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "socialNetworks{\"socialNetworkNames\":[\"PINTEREST\"]}"
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ModifySocialNetworkConnectionMutation_esMutation(\n  $input: ModifySocialNetworkConnectionInput!\n) {\n  modifySocialNetworkConnection(input: $input) {\n    removedId\n    user {\n      ...AccountSettings_user\n      ...PinterestPinIcon_user\n      id\n    }\n  }\n}\n\nfragment AccountSettings_user on User {\n  serviceId\n  facebookUserSocialNetwork: socialNetworks(socialNetworkNames: [FACEBOOK]) {\n    __typename\n    ...FacebookAccountSettings_userSocialNetwork\n    ... on Node {\n      id\n    }\n  }\n  pinterestUserSocialNetwork: socialNetworks(socialNetworkNames: [PINTEREST]) {\n    __typename\n    ...PinterestAccountSettings_userSocialNetwork\n    ... on Node {\n      id\n    }\n  }\n}\n\nfragment PinterestPinIcon_user on User {\n  serviceId\n  socialNetworks(socialNetworkNames: [PINTEREST]) {\n    __typename\n    ... on PinterestSocialNetwork {\n      ...PinterestConnectBoardModal_userSocialNetwork\n      status\n    }\n    ... on Node {\n      id\n    }\n  }\n}\n\nfragment PinterestConnectBoardModal_userSocialNetwork on PinterestSocialNetwork {\n  pinterest {\n    boards {\n      serviceId\n      name\n      url\n      id\n    }\n    id\n  }\n  userPreferences {\n    board\n  }\n}\n\nfragment FacebookAccountSettings_userSocialNetwork on UserSocialNetwork {\n  ... on FacebookSocialNetwork {\n    serviceId\n    socialId\n    status\n  }\n}\n\nfragment PinterestAccountSettings_userSocialNetwork on UserSocialNetwork {\n  ... on PinterestSocialNetwork {\n    ...PinterestConnectBoardModal_userSocialNetwork\n    serviceId\n    status\n    pinterest {\n      boards {\n        name\n        url\n        id\n      }\n      id\n    }\n    userPreferences {\n      board\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialNetworks/__generated__/ModifySocialNetworkConnectionMutation_esMutation.graphql.js